import axios from "axios"
import {
    getToken
} from "../../storage"
import {
    stringify
} from 'qs';

const instance = axios.create({
    baseURL: '/tyjrmh/api/',
    timeout: 5000,
    headers: {
        "Blade-Auth": getToken(),
        Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    }
})

// 课程详情
export async function classDetail(id) {
    return instance.get(`/blade-job-startup/sybtracoursesdetail/detail?id=${id}`)
}